import React from 'react';
import PlayerAvatar from '../playerAvatar/PlayerAvatar';

const PlayerAvatars = ({ players = [], maxDisplay = 9 }) => {
  const sortedPlayers = [...players].sort((a, b) => b.jgkTokens - a.jgkTokens);
  const displayPlayers = sortedPlayers.slice(0, maxDisplay);

  return (
    <div className="feedFriendImgs mb-2" style={{ minHeight: 38 }}>
      {displayPlayers.map((player, i) => (
        <PlayerAvatar player={player} index={i} key={player.playerId || i} />
      ))}
      {players.length > maxDisplay && (
        <span className="ms-2 small text-muted align-self-center">
          +{players.length - maxDisplay} more
        </span>
      )}
    </div>
  );
};

export default PlayerAvatars;
